/**
 * @desc 门店星际化配置信息
 */

import { RequestConfig, request } from 'umi';

function req(useless?: any, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.GeneralHttpResponse<Array<defs.store.StarEnum>>>(
    `/storeapi/api/v3/store/star/channels`,
    {
      method: 'get',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<Array<defs.store.StarEnum>>;
export default req;
